'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UIIcon from '../icon/UIIcon';
import UIIconButton from './UIIconButton';
import omit from '../utils/underscore/omit';
import { hidden } from '../utils/propTypes/decorators';
const EXCLUDED_ICON_BUTTON_PROP_NAMES = ['children', 'use', 'truncate', 'truncateStringProps'];
const ICON_NAMES = {
  first: 'first',
  previous: 'left',
  next: 'right',
  last: 'last'
};
export default function UIStepperButton(_ref) {
  let {
    iconName
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["iconName"]);

  return /*#__PURE__*/_jsx(UIIconButton, Object.assign({}, rest, {
    use: "tertiary-light",
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: ICON_NAMES[iconName]
    })
  }));
}
UIStepperButton.propTypes = Object.assign({}, omit(UIIconButton.propTypes, EXCLUDED_ICON_BUTTON_PROP_NAMES), {
  'aria-label': PropTypes.string.isRequired,
  active: hidden(PropTypes.bool),
  iconName: PropTypes.oneOf(Object.keys(ICON_NAMES)).isRequired
});
UIStepperButton.defaultProps = Object.assign({}, omit(UIIconButton.defaultProps, EXCLUDED_ICON_BUTTON_PROP_NAMES));
UIStepperButton.displayName = 'UIStepperButton';